<!--
    描述：通知配置信息
    日期：2022/06/24
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          <span style="font-weight: bold">通知配置信息：</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署人签署结果回调通知地址：htttps://523.eqb.comcxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署结果：  签署人签署完成
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署通知方式：1-短信；2-邮件
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name : 'detail_tab_nci',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.tab-main-page {
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>